import { update } from 'state/util';
import { STATUS } from 'state/requestStatus/reducer';

/**
 *  {
 *    message: null||"update status"
 *  }
 */

const initialState = {
  status: STATUS.NONE,
  message: null,
};

// user reducer, for registering, logging in, etc
export const donationReducer = (state, action) => {
  if (state === undefined)
    return initialState;

  switch(action.type) {
    case "LOGOUT_REQUESTED":
      return initialState;

    case "DONATION_PENDING":
      return update(state, {
        status: STATUS.PENDING,
        message: "Submitting..."
      });

    case "DONATION_SUCCESSFUL":
      return update(state, {
        status: STATUS.SUCCESS,
        message: action.payload.message,
      });

    case "DONATION_FAILED":
      return update(state, {
        status: STATUS.FAILURE,
        message: action.payload.message,
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/donation/reducer.js